import XCircleFillIcon from '../../../assets/icons/XCircleFill';
import Toast from '../../../components/ToastNotification';
import { useDeleteEmployeeMutation } from '../api/employeeApi';

const DeleteEmployee = ({ selectedRow, paginationState, onClose }) => {

  const [deleteEmployeeApi] = useDeleteEmployeeMutation();

  const handleDelete = async() => {
    try {
      await deleteEmployeeApi({id: selectedRow?.id}).unwrap();
      paginationState.setPagination({
        ...paginationState.pagination,
        pageIndex: 0
      });

      Toast.success('Employee deleted successfully');
      onClose();
    } catch (err) {
      Toast.error(err?.data?.message || err?.message || err?.error || 'Failed to fetch')
    }
  }
  return (
    <div className='overlay' onClick={onClose}>
      <div className='content_layout' onClick={(e) => e.stopPropagation()}>
        <div className='content_header'>
          <h2>Delete Employee</h2>
          <button className='close-btn' onClick={onClose}><XCircleFillIcon size={24} /></button>
        </div>

        <div className="content_body">
          <p>Are you sure you want to delete <strong>{selectedRow?.name}</strong> employee?</p>
          <div className='layout_footer'>
            <button onClick={handleDelete} className='save-btn'>Save</button>
            <button onClick={onClose} className='cancel-btn'>Cancel</button>
          </div>
        </div>

      </div>
    </div>
  )
}

export default DeleteEmployee
